import * as React from "react";
import { CircularProgress, withStyles } from "@material-ui/core";

const styles = {
  root: {
    height: "calc(100vh - 183px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column" as any,
  },
};

interface IProps {
  classes: any;
  saveFormate: boolean;
  searchTypeOrMaterial: string;
  searchTypeOrMaterialLength: number;
}

const LayerLoadingMessage = ({
  classes,
  saveFormate,
  searchTypeOrMaterial,
  searchTypeOrMaterialLength,
}: IProps) => {
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <CircularProgress
          size={50}
          style={{ margin: "0 auto", color: "#9FB408" }}
        />

        {saveFormate == true ? (
          <p>{"Salvando..."}</p>
        ) : (
          <>
            <p>{"Carregando"}</p>
            <p>{`Processando dados de ${searchTypeOrMaterial}`}</p>

            {searchTypeOrMaterialLength > 0 && (
              <p>{`${searchTypeOrMaterialLength} dados processados`}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(LayerLoadingMessage);



// WEBPACK FOOTER //
// ./src/modules/takeOff/components/layouts/LayerLoadingMessage.tsx